<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>

    <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta = null">
        <span class="text">{{ msgAlerta }}</span>
    </div>

    <div v-show="!modoAprovacao">
        <div v-if="lsDados.length > 0">
            <div class="table-wrapper row-space">
                <table>
                    <thead>
                        <tr>
                            <th>OS</th>
                            <th>Abertura</th>
                            <th>Nome/Identificação</th>
                            <th>Equipamento</th>
                            <th>Placa</th>
                            <th>Fornecedor</th>
                            <th>Valor</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr
                            v-for="(obj, index) in lsDados"
                            :key="obj.id"
                            @click="setAprovacao(obj)"
                            :class="{
                                'even-row': index % 2 === 0,
                                'odd-row': index % 2 !== 0,
                                'clickabe': true
                            }"
                        >
                            <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.cdos) }}</td>
                            <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtabertura) }}</td>
                            <td>{{ obj.nmos }}</td>
                            <td class="col-width-char30">{{ obj.nmequipamento }}</td>
                            <td class="col-width-char10 center">{{ obj.placa }}</td>
                            <td class="col-width-char40">{{ obj.nmfornecedor }}</td>
                            <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.orcamento_valor) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage = 1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ totalPaginas }}</div>
                <button :disabled="currentPage === totalPaginas" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === totalPaginas" class="buttom-pagination--last" @click="currentPage = totalPaginas; updatePaginatedData();" />
            </div>
        </div>

        <div v-else>
            <EmptyStateComponent
                title="Nenhum orçamento aguardando aprovação"
                message="Todos os orçamentos lançados já foram aprovados ou reprovados."
            />
        </div>

        <div class="row-space"></div>

        <div class="row-end">
            <button class="btn-small" @click="closeForm()">Fechar</button>
        </div>
    </div>

    <div v-if="modoAprovacao && objEdicao">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item info-card">
                    <span>Dados</span>
                    <strong>OS {{ Funcoes.formatInteger(objEdicao.cdos) }} - {{ objEdicao.nmos }}</strong>
                </div>

                <div class="form-item-char20 info-card info-card--highlight">
                    <span>Data Orçamento</span>
                    <strong class="center">{{ Funcoes.formatDateFromJson(objEdicao.dtabertura) }}</strong>
                </div>
            </div>

            <div class="row">
                <div class="form-item info-card">
                    <span>Equipamento/Veículo</span>
                    <strong>{{ objEdicao.nmequipamento }} · Placa {{ objEdicao.placa }}</strong>
                </div>

                <div class="form-item info-card">
                    <span>Fornecedor</span>
                    <strong>{{ objEdicao.nmfornecedor }}</strong>
                </div>

                <div class="form-item-char20 info-card info-card--highlight clickabe" @click="setOrcamentoValor()">
                    <span>Valor Orçamento</span>
                    <strong class="right">R$ {{ Funcoes.formatDecimal(objEdicao.orcamento_valor) }}</strong>
                </div>
            </div>
        </div>

        <div class="table-wrapper row-space">
            <table>
                <thead>
                    <tr>
                        <th>Item</th>
                        <th>Descrição</th>
                        <th>Horas</th>
                        <th>Vl. Hora</th>
                        <th>Total M.O.</th>
                        <th>Licitação M.O.</th>
                        <th>Qtd.</th>
                        <th>Vl. Unit.</th>
                        <th>Vl. Líquido</th>
                        <th>Licitação Peças</th>
                        <th>% Desc.</th>
                        <th>Vl. Desc.</th>
                        <th>Vl. Peças Aut.</th>
                        <th>Total Aut.</th>
                        <th class="col-acao"></th>
                    </tr>
                </thead>

                <tbody>
                    <tr
                        v-for="(item, index) in lsItens"
                        :key="item._uid"
                        :class="{
                            'even-row': index % 2 === 0,
                            'odd-row': index % 2 !== 0
                        }"
                    >
                        <td class="col-width-char6 right">{{ Funcoes.formatInteger(item.ordem) }}</td>

                        <td>
                            <div class="item-descricao">{{ item.descricao }}</div>
                            <div v-if="item.codigo" class="item-codigo">Cód.: {{ item.codigo }}</div>
                        </td>

                        <td class="col-width-char8 right">{{ formatValorOuVazio(item.qtdhoras) }}</td>
                        <td class="col-width-char10 right">{{ formatValorOuVazio(item.aut_vlmo) }}</td>
                        <td class="col-width-char10 right">{{ formatValorOuVazio(item.aut_ttmo) }}</td>

                        <td class="col-width-char25">
                            <select
                                v-if="temMaoDeObra(item)"
                                v-model="item.aut_idlicitacaomo"
                                class="input-full"
                                @change="aplicarLicitacaoMoItem(item)"
                            >
                                <option :value="null">Selecione</option>
                                <option
                                    v-for="lic in licitacoesMo"
                                    :key="lic.id"
                                    :value="lic.id"
                                >
                                    {{ lic.nmlicitacao }}
                                </option>
                            </select>

                            <span v-else class="text-muted">—</span>
                        </td>

                        <td class="col-width-char8 right">{{ formatValorOuVazio(item.qtdd) }}</td>
                        <td class="col-width-char10 right">{{ formatValorOuVazio(item.vlunitario) }}</td>
                        <td class="col-width-char10 right">{{ formatValorOuVazio(item.vlliquido) }}</td>

                        <td class="col-width-char25">
                            <select
                                v-if="temPeca(item)"
                                v-model="item.aut_idlicitacao"
                                class="input-full"
                                @change="aplicarLicitacaoPecaItem(item)"
                            >
                                <option :value="null">Selecione</option>
                                <option
                                    v-for="lic in licitacoesPecas"
                                    :key="lic.id"
                                    :value="lic.id"
                                >
                                    {{ lic.nmlicitacao }}
                                </option>
                            </select>

                            <span v-else class="text-muted">—</span>
                        </td>

                        <td class="col-width-char8 right">{{ formatValorOuVazio(item.aut_aldesconto) }}</td>
                        <td class="col-width-char10 right">{{ formatValorOuVazio(item.aut_vldesconto) }}</td>
                        <td class="col-width-char10 right">{{ formatValorOuVazio(item.aut_vlautorizado) }}</td>
                        <td class="col-width-char10 right total-item">{{ Funcoes.formatDecimal(totalAutorizadoItem(item)) }}</td>
                        <td class="col-acao">
                            <button type="button" class="btn-excluir-item" title="Excluir item" @click="excluirItem(index)">×</button>
                        </td>
                    </tr>
                </tbody>

                <tfoot>
                    <tr>
                        <td colspan="5" class="right"><strong>Totais</strong></td>
                        <td class="right"><strong>{{ Funcoes.formatDecimal(totalMaoDeObra) }}</strong></td>
                        <td colspan="3"></td>
                        <td class="right"><strong>{{ Funcoes.formatDecimal(totalLiquidoPecas) }}</strong></td>
                        <td></td>
                        <td></td>
                        <td class="right"><strong>{{ Funcoes.formatDecimal(totalDesconto) }}</strong></td>
                        <td class="right"><strong>{{ Funcoes.formatDecimal(totalAutorizadoPecas) }}</strong></td>
                        <td class="right"><strong>{{ Funcoes.formatDecimal(totalAutorizadoGeral) }}</strong></td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <div class="row-end">
            <button class="btn-small" @click="abrirModalItem">Inserir item</button>
            <button class="btn-small" @click="baixarAnexo(objEdicao.orcamento_idanexo)">Anexo</button>
            <button class="btn-small btn-save" @click="abrirModalAprovar">Aprovar</button>
            <button class="btn-small btn-cancel" @click="gravarDadosDesaprovacao">Reprovar</button>
            <button class="btn-small" @click="voltarLista">Voltar</button>
        </div>
    </div>

    <div v-if="modalItemVisivel" class="modal-overlay" @click.self="fecharModalItem">
        <div class="modal-content modal-item">
            <h3>Novo item do orçamento</h3>
            <div class="row row-space">
                <div class="form-item"><label class="label-caption">Descrição *</label><input v-model="itemEdicao.descricao" maxlength="200" v-uppercase /></div>
            </div>
            <div class="row row-space">
                <div class="form-item-char30"><label class="label-caption">Código</label><input v-model="itemEdicao.codigo" maxlength="50" v-uppercase /></div>
                <div class="form-item"><label class="label-caption">Operação</label><input v-model="itemEdicao.operacao" maxlength="100" /></div>
            </div>
            <div class="row row-space">
                <div class="form-item-char12"><label class="label-caption">Horas</label><input class="input-right" v-model="itemEdicao.qtdhoras" v-decimal maxlength="10" /></div>
                <div class="form-item-char15"><label class="label-caption">Vl. hora</label><input class="input-right" v-model="itemEdicao.vlunitario_mo" v-decimal maxlength="15" /></div>
                <div class="form-item-char12"><label class="label-caption">Quantidade</label><input class="input-right" v-model="itemEdicao.qtdd" v-decimal maxlength="10" /></div>
                <div class="form-item-char15"><label class="label-caption">Vl. unitário</label><input class="input-right" v-model="itemEdicao.vlunitario" v-decimal maxlength="15" /></div>
                <div class="form-item-char12"><label class="label-caption">Desconto</label><input class="input-right" v-model="itemEdicao.vldesconto" v-decimal maxlength="15" /></div>
            </div>
            <div v-if="erroModalItem" class="modal-item-erro">{{ erroModalItem }}</div>
            <div class="row-end">
                <button class="btn-small btn-save" @click="confirmarItem">Inserir</button>
                <button class="btn-small" @click="fecharModalItem">Cancelar</button>
            </div>
        </div>
    </div>

    <ConfirmModal ref="confirmAprovar" />
    <ConfirmModal ref="confirmDesaprovar" />
    <ModalJustificativaTexto ref="refModalJustificativa" />
    <ModalValorNumerico ref="modalValor" />
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import EmptyStateComponent from '@/components/EmptyStateComponent.vue';
import ModalJustificativaTexto from '@/components/modals/ModalJustificativaTexto.vue';
import ModalValorNumerico from '@/components/modals/ModalValorNumerico.vue';

const emit = defineEmits(['close']);

const confirmAprovar = ref(null);
const confirmDesaprovar = ref(null);
const modalValor = ref(null);
const refModalJustificativa = ref(null);

const isLoading = ref(false);
const msgAlerta = ref(null);

const lsDados = ref([]);
const lsDadosMain = ref([]);
const lsItens = ref([]);
const lsLicitacoes = ref([]);
const idsItensExcluidos = ref([]);
const modalItemVisivel = ref(false);
const erroModalItem = ref(null);
let itemUid = 0;

const novoItemVazio = () => ({
    descricao: '', codigo: '', operacao: '', qtdhoras: '', vlunitario_mo: '',
    qtdd: '', vlunitario: '', vldesconto: ''
});
const itemEdicao = ref(novoItemVazio());

const objEdicao = ref(null);
const modoAprovacao = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const showPagination = ref(false);

const totalPaginas = computed(() =>
    Math.ceil(lsDadosMain.value.length / itemsPerPage.value) || 1
);

const licitacoesMo = computed(() =>
    lsLicitacoes.value.filter(lic => lic.ckmo === 'S')
);

const licitacoesPecas = computed(() =>
    lsLicitacoes.value.filter(lic => lic.ckpecas === 'S')
);

const totalLiquidoPecas = computed(() =>
    lsItens.value.reduce((total, item) => total + valorNumber(item.vlliquido), 0)
);

const totalMaoDeObra = computed(() =>
    lsItens.value.reduce((total, item) => total + valorNumber(item.aut_ttmo), 0)
);

const totalDesconto = computed(() =>
    lsItens.value.reduce((total, item) => total + valorNumber(item.aut_vldesconto), 0)
);

const totalAutorizadoPecas = computed(() =>
    lsItens.value.reduce((total, item) => total + valorNumber(item.aut_vlautorizado), 0)
);

const totalAutorizadoGeral = computed(() =>
    lsItens.value.reduce((total, item) => total + totalAutorizadoItem(item), 0)
);

function closeForm() {
    emit('close');
}


async function setOrcamentoValor(){
    const rModal = await modalValor.value.show({
        titulo: `Alteração do Valor do Orçamento para OS ${objEdicao.value.cdos}`,
        label: 'Valor aprovado (R$)',
        valorInicial: objEdicao.value.orcamento_valor,
        minimo: 0,
    });
    if (!rModal.confirmado) return;

    try {
        isLoading.value = true;
        const resp = await Api.genericPut('/cad/manut_os', {
            id: objEdicao.value.id,
            orcamento_valor: rModal.valor,
            idlogin: globalStore.idlogin
        });

        if (resp.bolok === 1) {
            objEdicao.value.orcamento_valor = rModal.valor;
        } else {
            msgAlerta.value = resp?.erro || 'Não foi possível salvar alteração de dados.';
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}

function voltarLista() {
    modoAprovacao.value = false;
    objEdicao.value = null;
    lsItens.value = [];
    lsLicitacoes.value = [];
    idsItensExcluidos.value = [];
}

const valorNumber = Funcoes.numberFromValue;

function formatValorOuVazio(valor) {
    if (valor === null || valor === undefined || valor === '') return '';
    return Funcoes.formatDecimal(valor);
}

function temMaoDeObra(item) {
    return valorNumber(item.qtdhoras) > 0;
}

function temPeca(item) {
    return valorNumber(item.vlliquido) > 0 || valorNumber(item.vlunitario) > 0;
}

function buscarLicitacao(idlicitacao) {
    return lsLicitacoes.value.find(lic => Number(lic.id) === Number(idlicitacao));
}

function valorMoLicitacao(lic) {
    return valorNumber(
        lic.vlmo ??
        lic.vlunitario ??
        lic.vlvalor ??
        lic.valor ??
        lic.vllimite
    );
}

function limparDadosMo(item) {
    item.aut_idlicitacaomo = null;
    item.aut_vlmo = null;
    item.aut_ttmo = null;
}

function limparDadosPeca(item) {
    item.aut_idlicitacao = null;
    item.aut_aldesconto = null;
    item.aut_vldesconto = null;
    item.aut_vlautorizado = null;
}

function aplicarLicitacaoMoItem(item) {
    const lic = buscarLicitacao(item.aut_idlicitacaomo);

    if (!lic) {
        item.aut_vlmo = null;
        item.aut_ttmo = null;
        return;
    }

    item.aut_vlmo = valorMoLicitacao(lic);
    if (!item.aut_vlmo){
        item.aut_vlmo = (item.vlunitario_mo - (item.vlunitario_mo * lic.aldesconto / 100));

    }
    recalcularMaoDeObraItem(item);
}

function aplicarLicitacaoPecaItem(item) {
    const lic = buscarLicitacao(item.aut_idlicitacao);

    if (!lic) {
        item.aut_aldesconto = null;
        item.aut_vldesconto = null;
        item.aut_vlautorizado = valorNumber(item.vlliquido) || null;
        return;
    }

    item.aut_aldesconto = valorNumber(lic.aldesconto);
    recalcularPecaItem(item);
}

function recalcularMaoDeObraItem(item) {
    if (!temMaoDeObra(item)) {
        limparDadosMo(item);
        return;
    }

    const qtdHoras = valorNumber(item.qtdhoras);
    const vlMo = valorNumber(item.aut_vlmo);

    item.aut_ttmo = Funcoes.roundDecimal(qtdHoras * vlMo);
}

function recalcularPecaItem(item) {
    if (!temPeca(item)) {
        limparDadosPeca(item);
        return;
    }

    const vlLiquido = valorNumber(item.vlliquido);
    const alDesconto = valorNumber(item.aut_aldesconto);

    item.aut_vldesconto = Funcoes.roundDecimal(vlLiquido * alDesconto / 100);
    item.aut_vlautorizado = Funcoes.roundDecimal(vlLiquido - item.aut_vldesconto);
}

function totalAutorizadoItem(item) {
    return Funcoes.roundDecimal(valorNumber(item.aut_ttmo) + valorNumber(item.aut_vlautorizado));
}

function prepararItensParaEdicao(itens) {
    return (itens || []).map(item => {
        const novoItem = { ...item, _uid: ++itemUid, novo: false };

        if (!temMaoDeObra(novoItem)) {
            limparDadosMo(novoItem);
        } else {
            recalcularMaoDeObraItem(novoItem);
        }

        if (!temPeca(novoItem)) {
            limparDadosPeca(novoItem);
        } else if (novoItem.aut_idlicitacao) {
            recalcularPecaItem(novoItem);
        }

        return novoItem;
    });
}

function abrirModalItem() {
    itemEdicao.value = novoItemVazio();
    erroModalItem.value = null;
    modalItemVisivel.value = true;
}

function fecharModalItem() {
    modalItemVisivel.value = false;
    erroModalItem.value = null;
}

function reordenarItens() {
    lsItens.value.forEach((item, index) => { item.ordem = index + 1; });
}

function confirmarItem() {
    if (!itemEdicao.value.descricao?.trim()) {
        erroModalItem.value = 'Informe a descrição do item.';
        return;
    }

    const qtdHoras = valorNumber(itemEdicao.value.qtdhoras);
    const vlUnitarioMo = valorNumber(itemEdicao.value.vlunitario_mo);
    const quantidade = valorNumber(itemEdicao.value.qtdd);
    const vlUnitario = valorNumber(itemEdicao.value.vlunitario);
    const vlDesconto = valorNumber(itemEdicao.value.vldesconto);
    const vlBruto = Funcoes.roundDecimal(quantidade * vlUnitario);

    if (qtdHoras <= 0 && quantidade <= 0) {
        erroModalItem.value = 'Informe horas de mão de obra ou quantidade de peças.';
        return;
    }

    lsItens.value.push({
        ...itemEdicao.value,
        id: null,
        _uid: ++itemUid,
        novo: true,
        ordem: lsItens.value.length + 1,
        qtdhoras: qtdHoras,
        vlunitario_mo: vlUnitarioMo,
        vlmo: Funcoes.roundDecimal(qtdHoras * vlUnitarioMo),
        qtdd: quantidade,
        vlunitario: vlUnitario,
        vlbruto: vlBruto,
        vldesconto: vlDesconto,
        vlliquido: Funcoes.roundDecimal(vlBruto - vlDesconto),
        aut_idlicitacaomo: null,
        aut_vlmo: null,
        aut_ttmo: null,
        aut_idlicitacao: null,
        aut_aldesconto: null,
        aut_vldesconto: null,
        aut_vlautorizado: null,
        ckadd_manual: 'S'
    });
    fecharModalItem();
}

async function excluirItem(index) {
    const item = lsItens.value[index];
    const confirmado = await confirmDesaprovar.value.show({
        message: `Confirma exclusão do item "${item.descricao}"? A alteração será efetivada ao aprovar.`,
        confirmText: 'Sim',
        cancelText: 'Não'
    });
    if (!confirmado) return;

    if (item.id) idsItensExcluidos.value.push(item.id);
    lsItens.value.splice(index, 1);
    reordenarItens();
}

function validarAprovacao() {
    const validacoes = [];

    lsItens.value.forEach(item => {
        const prefixo = `Item ${Funcoes.formatInteger(item.ordem)} - ${item.descricao}`;

        if (temMaoDeObra(item) && !item.aut_idlicitacaomo) {
            validacoes.push(`${prefixo}: informe a licitação de mão de obra.`);
        }

        if (temPeca(item) && !item.aut_idlicitacao) {
            validacoes.push(`${prefixo}: informe a licitação de peças/desconto.`);
        }
    });

    if (validacoes.length > 0) {
        msgAlerta.value = `ATENÇÃO:\n${validacoes.join('\n')}`;
        return false;
    }

    return true;
}

async function abrirModalAprovar() {
    if (!validarAprovacao()) return;

    const confirmado = await confirmAprovar.value.show({
        message: 'Confirma aplicação dos valores e aprovação do orçamento?',
        confirmText: 'Sim',
        cancelText: 'Não'
    });

    if (confirmado) gravarDadosAprovacao();
}


async function baixarAnexo(idanexo) {
    if (!idanexo) {
        msgAlerta.value = 'ATENÇÃO: orçamento sem anexo vinculado.';
        return;
    }

    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const r = await Api.genericPost('/main/solicitar/download', { id: idanexo });

        if (r.bolok === 1) {
            window.open(r.download_url, '_blank');
        } else {
            msgAlerta.value = `ATENÇÃO: ${r.erro || r.error || 'Não foi possível gerar o link do anexo.'}`;
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {
        isLoading.value = false;
    }
}

async function gravarDadosAprovacao() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        for (const id of idsItensExcluidos.value) {
            await Api.genericDelete(
                'manut_os_item',
                id,
                globalStore.idusuario
            );
        }

        for (const item of lsItens.value) {
            recalcularMaoDeObraItem(item);
            recalcularPecaItem(item);

            const payloadItem = {
                id: item.id,

                ...(item.novo ? {
                    idos: objEdicao.value.id,
                    codigo: item.codigo,
                    descricao: item.descricao,
                    operacao: item.operacao,
                    qtdhoras: valorNumber(item.qtdhoras),
                    vlunitario_mo: valorNumber(item.vlunitario_mo),
                    vlmo: valorNumber(item.vlmo),
                    qtdd: valorNumber(item.qtdd),
                    vlunitario: valorNumber(item.vlunitario),
                    vlbruto: valorNumber(item.vlbruto),
                    vldesconto: valorNumber(item.vldesconto),
                    vlliquido: valorNumber(item.vlliquido),
                    ckadd_manual: 'S'
                } : {}),

                ordem: item.ordem,
                aut_idlicitacaomo: temMaoDeObra(item) ? item.aut_idlicitacaomo : null,
                aut_vlmo: temMaoDeObra(item) ? valorNumber(item.aut_vlmo) : null,
                aut_ttmo: temMaoDeObra(item) ? valorNumber(item.aut_ttmo) : null,

                aut_idlicitacao: temPeca(item) ? item.aut_idlicitacao : null,
                aut_aldesconto: temPeca(item) ? valorNumber(item.aut_aldesconto) : null,
                aut_vldesconto: temPeca(item) ? valorNumber(item.aut_vldesconto) : null,
                aut_vlautorizado: temPeca(item) ? valorNumber(item.aut_vlautorizado) : null,

                idlogin: globalStore.idlogin
            };

            const respItem = await Api.genericPut('/cad/manut_os_item', payloadItem);

            if (respItem.bolok != 1) {
                throw new Error(respItem.erro || respItem.error || 'Não foi possível gravar item do orçamento.');
            }
        }

        const payloadOS = {
            id: objEdicao.value.id,
            aprovacao_idlogin: globalStore.idlogin,
            aprovacao_valor: valorNumber(totalAutorizadoGeral.value),
            aprovacao_ok: 'S',
            idlogin: globalStore.idlogin
        };

        const respOs = await Api.genericPut('/cad/manut_os', payloadOS);

        if (respOs.bolok != 1) {
            throw new Error(respOs.erro || respOs.error || 'Não foi possível gravar dados da OS.');
        }

        voltarLista();
        await lerDados();
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function gravarDadosDesaprovacao() {
    const resultado = await refModalJustificativa.value.show({
        titulo: 'Motivo da reprovação:',
        maxlength: 200,
    });
    if (!resultado.confirmado) return;

    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const payloadOS = {
            id: objEdicao.value.id,
            aprovacao_idlogin: globalStore.idlogin,
            aprovacao_valor: 0,
            aprovacao_ok: 'N',
            aprovacao_justificativa: resultado.justificativa,
            idlogin: globalStore.idlogin
        };

        const respOs = await Api.genericPut('/cad/manut_os', payloadOS);

        if (respOs.bolok != 1) {
            throw new Error(respOs.erro || respOs.error || 'Não foi possível gravar dados da OS.');
        }

        voltarLista();
        await lerDados();
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function lerDados() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const payload = {
            idmunicipio: globalStore.idmunicipio,
            intparam1: 5,
            idlogin: globalStore.idlogin
        };

        const req = await Api.genericPost('/dados/manut_os', payload);

        lsDadosMain.value = req || [];
        currentPage.value = 1;
        showPagination.value = lsDadosMain.value.length > itemsPerPage.value;

        updatePaginatedData();
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}

async function setAprovacao(obj) {
    objEdicao.value = obj;

    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const reqItens = await Api.genericPost('/frota/manut_os/itens/orcamento', {
            idreferencia: obj.id
        });

        lsItens.value = prepararItensParaEdicao(reqItens);

        const reqLic = await Api.genericPost('/frota/licitacoes/ativas', {
            idmunicipio: globalStore.idmunicipio,
            idfornecedor: obj.idfornecedor
        });

        lsLicitacoes.value = reqLic || [];
        modoAprovacao.value = true;
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}

function updatePaginatedData() {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = startIndex + itemsPerPage.value;

    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados);
</script>

<style scoped>
.item-descricao {
    font-weight: 600;
    color: #1f2937;
}

.item-codigo {
    margin-top: 3px;
    font-size: 11px;
    color: #6b7280;
}

.text-muted {
    color: #9ca3af;
    font-size: 13px;
}

.total-item {
    font-weight: 700;
    color: #111827;
}

.input-full {
    width: 100%;
    min-width: 180px;
}

.col-acao { width: 42px; min-width: 42px; text-align: center; }

.btn-excluir-item {
    display: inline-flex; align-items: center; justify-content: center;
    width: 26px; height: 26px; padding: 0;
    border: 1px solid #c95d5d; border-radius: 5px;
    background: #fff; color: #9b1c1c; font-size: 20px;
    line-height: 1; cursor: pointer;
}

.btn-excluir-item:hover { background: #fbeaea; }
.modal-item { width: min(900px, 94vw); }
.modal-item h3 { margin: 0 0 16px; color: #25413e; }
.modal-item .row + .row { margin-top: 10px; }
.modal-item-erro {
    margin-top: 12px; padding: 8px 10px; border-radius: 4px;
    background: #fff8e1; color: #8a5a00;
}
</style>
